export default {
  loggedIn: false,
  user: null,
  token: null,
  refreshToken: null,
}
